import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { getQueryConfig } from 'src/features/price-policies/constants'

export const getBranchOfficeByCarLots = async (params) => {
    const {carLots, brands = [], models = [], versions = []} = params
    let query = ''
    carLots.forEach(id => {
        query = query + 'car_lot_id[]=' + id + '&'
    });

    brands.forEach(brand => {
        query = query + 'brands[]=' + brand.value + '&'
    });

    models.forEach(model => {
        query = query + 'models[]=' + model.value + '&'
    });

    versions.forEach(version => {
        query = query + 'versions[]=' + version.value + '&'
    });

    const queryConfig = getQueryConfig(params)

    query = query.slice(0,-1)

    try {
        const { data: data2 } = await axios(`${REACT_APP_API}/bonifications/branchOfficeForBonification?${query}&${queryConfig}`)
        return data2
    } catch (error) {
        console.log(`Error getBranchOfficeByCarLots `, error)
        return error;
    }
}
